// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Added Comment Lines
// MODIFIED DATE: 07-12-2025

/* eslint-disable import/no-anonymous-default-export */
import DemandFollowupActionTypes from './demand-followup-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// Demand Followup List Response
	getDemandFollowupListResponse: null,
	getDemandFollowupListArr: [],
	// Demand Followup Excel Export Response
	getDemandFollowupListExcelResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		// Demand Follow up List Start
		case DemandFollowupActionTypes.GET_DEMAND_FOLLOWUP_LIST_SUCCESS:
			return {
				...state,
				getDemandFollowupListResponse: action.payload,
				getDemandFollowupListArr: docodeHexResponse(action.payload, 'DemandFollowupKey'),
			};

		case DemandFollowupActionTypes.GET_DEMAND_FOLLOWUP_LIST_FAILURE:
			return { ...state, getDemandFollowupListResponse: action.payload };

		case DemandFollowupActionTypes.GET_DEMAND_FOLLOWUP_LIST_RESPONSE_CHANGED:
			return { ...state, getDemandFollowupListResponse: null };
		// Demand Follow up List End

		default:
			return state;
	}
};
